import { ManagementActionTypes } from 'types';

export const getCopy = (archived: boolean) => ({
  [ManagementActionTypes.bom]: {
    title: `${archived ? 'Unarchive' : 'Archive'} BOM`,
    body: `Are you sure you want to ${
      archived ? 'unarchive' : 'archive'
    } this BOM?`,
    successMessage: `BOM successfully ${archived ? 'unarchived' : 'archived'}`,
    submitButton: archived ? 'Unarchive ' : 'Archive ',
  },
  [ManagementActionTypes.productionRun]: {
    title: `${archived ? 'Unarchive' : 'Archive'} Program`,
    body: `Are you sure you want to ${
      archived ? 'unarchive' : 'archive'
    } this Program?`,
    successMessage: `Program successfully ${
      archived ? 'unarchived' : 'archived'
    }`,
    submitButton: archived ? 'Unarchive ' : 'Archive ',
  },
  [ManagementActionTypes.purchaseOrder]: {
    title: `${archived ? 'Unarchive' : 'Archive'} Purchase Order`,
    body: `Are you sure you want to ${
      archived ? 'unarchive' : 'archive'
    } this Purchase Order?`,
    successMessage: `Purchase Order successfully ${
      archived ? 'unarchive' : 'archive'
    }`,
    submitButton: archived ? 'Unarchive ' : 'Archive ',
  },
  [ManagementActionTypes.team]: {
    title: archived ? 'Mark Team Active' : 'Mark Team Inactive',
    body: `Are you sure you want to mark this team ${
      archived ? 'active' : 'inactive'
    }?`,
    successMessage: `Team successfully marked ${
      archived ? 'active' : 'inactive'
    }`,
    submitButton: archived ? 'Mark Active ' : 'Mark Inactive ',
  },
});
